import React, { FC, useEffect, useMemo, useState } from 'react'
import { State } from 'index'
import { useDispatch, useSelector } from 'react-redux'
import { startOfMonth } from 'date-fns'
import { getStocks } from 'reducks/stock/selectors'
import { getSchedules } from 'reducks/schedule/selectors'
import { getStoreRef } from 'reducks/auth/selectors'
import { IndividualScheduleEditCard } from 'components/Card'
import { StockType } from 'types/stock'
import { ScheduleType } from 'types/schedule'
import { BreadType } from 'types/bread'
import { dateToString } from 'lib/helper'
import { useSaveIndividualPreorderSchedule } from 'hooks/stock'
import { fetchStoreCalendars } from 'reducks/storeCalendar/operations'

type Props = {
  bread: BreadType
  checkedOrderTypes: string[]
  date: Date
}

const IndividualPreorderScheduleModal: FC<Props> = (props) => {
  const { bread, checkedOrderTypes, date } = props
  const type = 'preorder'
  const dispatch = useDispatch()
  const stocks: StockType[] = useSelector((state: State) => getStocks(state))
  const schedules: ScheduleType[] = useSelector((state: State) => getSchedules(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const [stockList, setStockList] = useState<StockType[]>([])

  const schedulesOfBread: ScheduleType[] = useMemo(() => {
    if (!bread) return []
    return schedules.filter((schedule) => schedule.bread_ref.id === bread.bread_ref?.id)
  }, [schedules, bread])

  const saveIndividualPreorderSchedule = useSaveIndividualPreorderSchedule(
    bread,
    checkedOrderTypes,
    date,
    stockList,
    storeRef
  )

  // 対象商品のstocksをローカルのstateにセット
  useEffect(() => {
    if (!bread) return
    const stocksOfBread = stocks.filter((stock) => stock.bread_ref.id === bread.bread_ref?.id && stock.type === type)
    setStockList([...stocksOfBread])
  }, [stocks, bread, type])

  // 臨時営業日を取得する
  useEffect(() => {
    if (!storeRef) return
    dispatch(fetchStoreCalendars(storeRef, startOfMonth(date)))
  }, [date, storeRef])

  return (
    <IndividualScheduleEditCard
      bread={bread}
      date={date}
      isFixedDate={true}
      saveIndividualSettings={saveIndividualPreorderSchedule}
      schedules={schedulesOfBread}
      stocks={stockList.filter((stock) => stock.date === dateToString(date))}
      type={type}
    />
  )
}

export default IndividualPreorderScheduleModal
